import { createAsyncThunk } from "@reduxjs/toolkit";
import { VoucherServices } from "Services/axios/Voucher.Service";
import { toast } from "react-toastify";
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchVouchers = createAsyncThunk(
	"Vouchers/fetchVouchers",
	async (filters) => {
		try {
			const response = await VoucherServices.getAll(filters);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const submitVoucher = createAsyncThunk(
	"addVoucher/submitVoucher",
	async (data) => {
		try {
			const formData = new FormData();
			formData.append("code", data.code);
			formData.append("is_percentage", data.is_percentage);
			formData.append("discount", data.discount);
			formData.append("valid_until", data.valid_until);
			formData.append("minimum_nominal", data.minimum_nominal);
			data.membership.forEach((membership, index) => {
				formData.append(`membership[${index}]`, membership.id);
			});
			let response;
			if (data.isUpdate) {
				response = await VoucherServices.update(data.id, formData);
			} else {
				response = await VoucherServices.create(formData);
			}
			toast.success(data.isUpdate ? "Voucher berhasil diubah." : "Voucher berhasil ditambahkan.", {
				position: toast.POSITION.TOP_RIGHT,
			});
			data.successCallback && data.successCallback();
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const deleteVoucher = createAsyncThunk(
	"Vouchers/deleteVoucher",
	async (id) => {
		try {
			const response = await VoucherServices.delete(id);
			toast.success(response.data.message, {
				position: toast.POSITION.TOP_RIGHT,
			});
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const replicateVoucher = createAsyncThunk(
	"Vouchers/replicateVoucher",
	async (id) => {
		try {
			const response = await VoucherServices.replicate(id);
			return response;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const exportVoucher = createAsyncThunk(
	'Vouchers/exportVoucher',
	async ({ id, status }) => {
		try {
			const response = await VoucherServices.export(id, status);
			const fileLink = response.data.file;
			window.open(fileLink, '_blank');
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);